import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "shell info-container info-padding" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_basic_information = _resolveComponent("basic-information")
  const _component_residents = _resolveComponent("residents")
  const _component_devices = _resolveComponent("devices")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadCrumb }, null, 8, ["headers"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_basic_information, {
        "basic-information-data": _ctx.basicInformationData,
        "basic-information-edit-form": _ctx.basicInformationEditForm,
        onUpdateBasicInformation: _ctx.getInfo
      }, null, 8, ["basic-information-data", "basic-information-edit-form", "onUpdateBasicInformation"]),
      _hoisted_2,
      _createVNode(_component_residents, { "residents-list": _ctx.residentData }, null, 8, ["residents-list"]),
      _hoisted_3,
      _createVNode(_component_devices, { "devices-list": _ctx.devicesData }, null, 8, ["devices-list"])
    ])
  ]))
}